import type { GetUserProfileResponse } from '@gat-ship/types'
import { useUserApiCalls } from '../composables/useUserApiCalls'
import { computed, ref } from 'vue'

export function useUserProfileDataSource() {
  const userProfile = ref<GetUserProfileResponse>()
  const { getUserProfileRequest } = useUserApiCalls()
  const userProfileGetter = computed(() => userProfile.value)

  function setUserProfile(user: GetUserProfileResponse) {
    userProfile.value = user
  }

  const userId = computed(() => userProfile.value!.userId)

  const isTenantAdmin = computed(
    () => userProfile.value?.isTenantAdmin ?? false
  )

  const isSupportUser = computed(() => {
    if (!userProfile.value) {
      return false
    }
    return (
      (userProfile.value.email.endsWith('@gatship.com') &&
        userProfile.value.homeTenantName.toLowerCase().includes('gat-ship')) ||
      userProfile.value.actor !== undefined
    )
  })

  async function fetchUserProfile() {
    const result = await getUserProfileRequest()
    if (result) {
      setUserProfile(result)
    }
    return result
  }

  return {
    profile: userProfileGetter,
    fetchUserProfile,
    id: userId,
    isTenantAdmin,
    isSupportUser
  }
}
